<div class="login__container">
  <div class="login_panel">
    <span class="logo">
      <img src="../../../../assets/images/App-Logo.svg" alt="" />
    </span>

    <!-- <div class="form_header">Recover Your Password</div> -->

    <div class="form_sub_header col-md-6">
      Enter your email address to reset your password
    </div>

    <form [formGroup]="recoverPasswordForm">
      <div class="row">
        <div class="col-md-12 no-padding">
          <div class="form-group">
            <span class="has-float-label">
              <input
                class="form-control"
                id="email"
                type="text"
                password
                placeholder=" "
                formControlName="email"
                />
              <label for="email">Enter Your Email Address</label>
            </span>
            @if (
              recoverPasswordForm.get('email').errors &&
              (recoverPasswordForm.get('email').dirty ||
              recoverPasswordForm.get('email').touched)
              ) {
              <div
                class="validation-message"
                >
                <span
                  class="validation-message"
                  [hidden]="!recoverPasswordForm.get('email').hasError('required')"
                  >
                  {{ validationMessage.email.required }}
                  <br />
                </span>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="bottom_text">
        <a [routerLink]="['../sign-in']">
          Return to Sign In
        </a>
      </div>
      @if (!isLoading) {
        <button
          class="form_button"
          [disabled]="!recoverPasswordForm.valid"
          (click)="sendLink()"
          >
          <span>Send Link</span>
        </button>
      }
      @if (isLoading) {
        <div class="sbl-circ-path text-center"></div>
      }
    </form>
  </div>
</div>

@if (isResetLinkSent) {
  <div class="password_reset-modal">
    <div class="password_reset-div">
      <div class="password_reset-subtitle">Password reset link has been sent to your email</div>
      <div class="password_reset-action">
        <button class="yes" (click)="isResetLinkSent = false">OK</button>
      </div>
    </div>
  </div>
}
